import React from 'react';
import TextInput from '../Common/TextInput.jsx';
import Constants from '../../constants/ApplicationConstants.js';

const BankAccountDetails = React.createClass({
    propTypes: {
      section: React.PropTypes.string.isRequired,
      data: React.PropTypes.object.isRequired,
      errorList: React.PropTypes.array.isRequired,
      onBlur: React.PropTypes.func.isRequired
    },
    getDefaultProps() {
      return {
        section: '',
        index: ''
      };
    },
    createId(id){
        return this.props.section + id + this.props.index;
    },
    render() {
        return (
            <div>
                <TextInput id={this.createId('accountHolderName')}
                           model="accountHolderName"
                           label={Constants.bankAccountDetailsLabel.accountHolderName}
                           value={this.props.data.accountHolderName}
                           onBlur={this.props.onBlur}
                           errorList={this.props.errorList} />
                <TextInput id={this.createId('branchNumber')}
                           model="branchNumber"
                           label={Constants.bankAccountDetailsLabel.branchNumber}
                           value={this.props.data.branchNumber}
                           onBlur={this.props.onBlur}
                           errorList={this.props.errorList} />
                <TextInput id={this.createId('accountNumber')}
                           model="accountNumber"
                           label={Constants.bankAccountDetailsLabel.accountNumber}
                           value={this.props.data.accountNumber}
                           onBlur={this.props.onBlur}
                           errorList={this.props.errorList} />  
            </div>);
    }
  }
);

module.exports = BankAccountDetails;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/BankAccountDetails.jsx